import { render, staticRenderFns } from "./AddFaq.vue?vue&type=template&id=5c7c9007&scoped=true&"
import script from "./AddFaq.vue?vue&type=script&lang=js&"
export * from "./AddFaq.vue?vue&type=script&lang=js&"
import style0 from "./AddFaq.vue?vue&type=style&index=0&id=5c7c9007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c9007",
  null
  
)

export default component.exports